import { render, staticRenderFns } from "./OtherImagingResults.vue?vue&type=template&id=3333281e&"
import script from "./OtherImagingResults.vue?vue&type=script&lang=js&"
export * from "./OtherImagingResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports